"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utilities = require("../../../utilities");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SortResults = exports["default"] = /*#__PURE__*/function () {
  function SortResults() {
    _classCallCheck(this, SortResults);
    _defineProperty(this, "results", null);
    _defineProperty(this, "sortKey", null);
    _defineProperty(this, "direction", "down");
  }
  return _createClass(SortResults, [{
    key: "setResults",
    value: function setResults(results) {
      this.results = results;
      return this;
    }
  }, {
    key: "setSortKey",
    value: function setSortKey(sortKey) {
      this.sortKey = sortKey;
      return this;
    }
  }, {
    key: "setDirection",
    value: function setDirection(direction) {
      this.direction = direction;
      return this;
    }
  }, {
    key: "resultsContainSortKey",
    value: function resultsContainSortKey() {
      var _this = this;
      return this.results.some(function (result) {
        return result[_this.sortKey];
      });
    }
  }, {
    key: "isSortable",
    value: function isSortable() {
      return this.results && this.results.length > 1 && this.sortKey !== null && this.resultsContainSortKey();
    }
  }, {
    key: "getSortFormula",
    value: function getSortFormula(x, y) {
      if (this.direction === "down") {
        return x > y ? -1 : x < y ? 1 : 0;
      } else {
        return x < y ? -1 : x > y ? 1 : 0;
      }
    }
  }, {
    key: "sort",
    value: function sort() {
      var _this2 = this;
      /* istanbul ignore else */
      if (this.isSortable()) {
        this.results = _utilities.utilities.immutableSort(this.results, function (a, b) {
          var x = a[_this2.sortKey];
          var y = b[_this2.sortKey];
          return _this2.getSortFormula(x, y);
        });
      }
    }
  }]);
}();